import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLCAWizard from './FNOLCAWizard';
import FNOLCAVehiclesPage from './pages/Vehicles/VehiclesPage';
import FNOLCATypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLCATypeOfRepairPage from './pages/TypeOfRepair/TypeOfRepairPage';
import FNOLCARepairFacilityPage from './pages/RepairFacility/RepairFacilityPage';
import FNOLCACollisionDetailsPage from './pages/Details/Collision/CollisionDetailsPage';
import FNOLCAGlassDetailsPage from './pages/Details/Glass/GlassDetailsPage';
import FNOLCATheftDetailsPage from './pages/Details/Theft/TheftDetailsPage';
import FNOLCARepairFacilityMapPage from './pages/RepairFacilityMap/RepairFacilityMapPage';

setComponentMapOverrides(
    {
        FNOLCAWizard: { component: 'FNOLCAWizard' },
        FNOLCATypeOfIncidentPage: { component: 'FNOLCATypeOfIncidentPage' },
        FNOLCAVehiclesPage: { component: 'FNOLCAVehiclesPage' },
        FNOLCATypeOfRepairPage: { component: 'FNOLCATypeOfRepairPage' },
        FNOLCARepairFacilityPage: { component: 'FNOLCARepairFacilityPage' },
        FNOLCACollisionDetailsPage: { component: 'FNOLCACollisionDetailsPage' },
        FNOLCAGlassDetailsPage: { component: 'FNOLCAGlassDetailsPage' },
        FNOLCATheftDetailsPage: { component: 'FNOLCATheftDetailsPage' },
        FNOLCARepairFacilityMapPage: { component: 'FNOLCARepairFacilityMapPage' }
    },
    {
        FNOLCAWizard,
        FNOLCATypeOfIncidentPage,
        FNOLCAVehiclesPage,
        FNOLCATypeOfRepairPage,
        FNOLCARepairFacilityPage,
        FNOLCACollisionDetailsPage,
        FNOLCAGlassDetailsPage,
        FNOLCATheftDetailsPage,
        FNOLCARepairFacilityMapPage
    }
);

export {
    FNOLCAWizard as default
};
